import { render, staticRenderFns } from "./RequestDetailsNew.vue?vue&type=template&id=54171382&scoped=true"
import script from "./RequestDetailsNew.vue?vue&type=script&lang=ts"
export * from "./RequestDetailsNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetailsNew.vue?vue&type=style&index=0&id=54171382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54171382",
  null
  
)

export default component.exports